import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[var(--ls-bg-light)] border-t border-[var(--ls-border)] mt-auto" role="contentinfo" aria-label="Site footer">
      <div className="ls-container py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <img src="/logo.png" alt="LegaSecure" className="h-10 w-auto" />
            </div>
            <p className="text-sm text-[var(--ls-text-light)] mb-4">Your Legacy. Secured.</p>
            <div className="flex gap-3">
              <a href="https://facebook.com/legasecure" className="w-8 h-8 rounded-full bg-[var(--ls-navy)] flex items-center justify-center text-white text-xs hover:bg-[var(--ls-gold)] transition-colors"><i className="fa-brands fa-facebook-f"></i></a>
              <a href="https://instagram.com/legasecure" className="w-8 h-8 rounded-full bg-[var(--ls-navy)] flex items-center justify-center text-white text-xs hover:bg-[var(--ls-gold)] transition-colors"><i className="fa-brands fa-instagram"></i></a>
              <a href="https://linkedin.com/company/legasecure" className="w-8 h-8 rounded-full bg-[var(--ls-navy)] flex items-center justify-center text-white text-xs hover:bg-[var(--ls-gold)] transition-colors"><i className="fa-brands fa-linkedin-in"></i></a>
            </div>
          </div>

          <div>
            <h4 className="font-['Crimson_Pro'] text-[var(--ls-navy)] font-bold mb-3">Services</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/guides/special-power-of-attorney-philippines" className="text-[var(--ls-text-light)] hover:text-[var(--ls-gold)]">Online SPA</Link></li>
              <li><Link to="/guides/guardian-mandate-filipino-children" className="text-[var(--ls-text-light)] hover:text-[var(--ls-gold)]">Guardian Mandate</Link></li>
              <li><Link to="/guides/digital-legacy-planning" className="text-[var(--ls-text-light)] hover:text-[var(--ls-gold)]">Digital Vault</Link></li>
              <li><Link to="/guides/estate-planning-for-ofw" className="text-[var(--ls-text-light)] hover:text-[var(--ls-gold)]">Estate Planning</Link></li>
              <li><Link to="/blog" className="text-[var(--ls-text-light)] hover:text-[var(--ls-gold)]">Blog</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-['Crimson_Pro'] text-[var(--ls-navy)] font-bold mb-3">Company</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="https://legasecure.com/about" className="text-[var(--ls-text-light)] hover:text-[var(--ls-gold)]">About Us</a></li>
              <li><a href="https://legasecure.com/request-information" className="text-[var(--ls-text-light)] hover:text-[var(--ls-gold)]">Request Information</a></li>
              <li><a href="https://legasecure.com/contact" className="text-[var(--ls-text-light)] hover:text-[var(--ls-gold)]">Contact</a></li>
              <li><a href="https://legasecure.com/privacy-policy" className="text-[var(--ls-text-light)] hover:text-[var(--ls-gold)]">Privacy Policy</a></li>
              <li><a href="https://legasecure.com/terms-of-use" className="text-[var(--ls-text-light)] hover:text-[var(--ls-gold)]">Terms of Use</a></li>
              <li><a href="https://legasecure.com/service-promise" className="text-[var(--ls-text-light)] hover:text-[var(--ls-gold)]">Service Promise</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-['Crimson_Pro'] text-[var(--ls-navy)] font-bold mb-3">Address</h4>
            <p className="text-sm text-[var(--ls-text-light)] leading-relaxed">
              103 Suite C, 10th Street,<br />
              New Manila, 1112, Quezon City<br />
              Philippines
            </p>
            <p className="text-sm text-[var(--ls-text-light)] mt-3">
              <a href="mailto:info@legasecure.com" className="hover:text-[var(--ls-gold)]">info@legasecure.com</a>
            </p>
          </div>
        </div>

        <div className="border-t border-[var(--ls-border)] mt-8 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-[var(--ls-text-light)]">&copy; {new Date().getFullYear()} LegaSecure. All rights reserved.</p>
          <p className="text-xs text-[var(--ls-text-light)]">
            <Link to="/blog" className="hover:text-[var(--ls-gold)]">Blog</Link>
            {' | '}
            <Link to="/all-cities" className="hover:text-[var(--ls-gold)]">Cities</Link>
            {' | '}
            <Link to="/all-countries" className="hover:text-[var(--ls-gold)]">OFW Countries</Link>
            {' | '}
            <a href="https://legasecure.com/privacy-policy" className="hover:text-[var(--ls-gold)]">Privacy</a>
            {' | '}
            <a href="https://legasecure.com/terms-of-use" className="hover:text-[var(--ls-gold)]">Terms</a>
          </p>
        </div>
      </div>

      <div className="bg-[var(--ls-navy)] py-3">
        <p className="text-center text-xs text-white/60">
          Legal Disclaimer: This website provides general information about estate planning and legal processes in the Philippines. It is not a substitute for professional legal advice. For specific legal matters, consult a licensed attorney. LegaSecure Guide is an informational resource operated by <a href="https://legasecure.com" className="underline text-white/80">LegaSecure</a>.
        </p>
      </div>
    </footer>
  );
}
